export const homeRoutes = {
  name: 'Home',
  to: '/',
  exact: true,
  icon: 'chart-pie',
  children: [
    {
      to: '/',
      name: 'Dashboard',
      exact: true
    }
  ]
};

export const authenticationRoutes = {
  name: 'Authentication',
  to: '/authentication',
  icon: 'lock',
  children: [
    {
      to: '/authentication/basic',
      name: 'Basic',
      children: [
        { to: '/authentication/basic/login', name: 'Login' },
        // { to: '/authentication/basic/login-otp', name: 'Login OTP' },
        { to: '/authentication/basic/logout', name: 'Logout' }
      ]
    }
  ]
};

export const pageRoutes = {
  name: 'Forms',
  to: '/pages',
  icon: 'copy',
  children: [
    { to: '/pages/member-type-check', name: 'Application Form' },
    { to: '/pages/billing-history', name: 'Billing History' },
    { to: '/pages/manage-proof-payments', name: 'Manage Proof of Payments' }
  ]
};

export const initialisedUserRoutes = (id, type) => ({
  name: 'Forms',
  to: '/pages',
  icon: 'copy',
  children: [
    type === 'new'
      ? { to: `/pages/apply/${id}`, name: 'Application Form' }
      : { to: `/pages/apply-mini/${id}`, name: 'Application Form' },
    { to: '/pages/billing-history', name: 'Billing History' },
    { to: '/pages/manage-proof-payments', name: 'Manage Proof of Payments' }
  ]
});

export default [homeRoutes, pageRoutes, initialisedUserRoutes];
